<div class="user" mat-button>
  <button
    class="user__settings"
    [class]="{
      'user__settings--active': menuIsOpen,
      'user__settings--impersonating': isImpersonating(),
    }"
    [mat-menu-trigger-for]="settingsMenu"
    (click)="menuIsOpen = true"
  >
    @if (user$ | async; as user) {
      <app-assignee-avatar
        class="user__avatar"
        [displayName]="user.scdName"
        [userIdentifier]="user.scdEMail"
        size="user"
      />
      @if (user?.employeeId) {
        <div class="user__credentials">
          <div class="strong">{{ user.firstname }}</div>
          <div>{{ 'employees.' + user.role | translate }}</div>
        </div>
      } @else {
        <div class="user__credentials">
          <div class="strong">{{ 'employees.loadingName' | translate }}</div>
          <div>----------------------</div>
        </div>
      }
    } @else {
      <app-assignee-avatar class="user__avatar" size="user" />
    }
  </button>
  <mat-menu class="user__menu" #settingsMenu="matMenu" (closed)="menuIsOpen = false">
    <span class="user__information" mat-menu-item>
      <p>
        {{ 'header.userSettings.lastMonthlySettlement' | translate }}:
        {{ lastMonthlySettlement | localizedDate: true }}
        <br />
        {{ 'header.userSettings.lastApprovedMonth' | translate }}:
        {{ lastApprovedMonth | localizedDate: true }}
      </p>
      <p>
        {{ 'header.userSettings.accountingMonth' | translate }}:
        {{ accountingMonth | localizedDate: true }}
        <br />
        {{ 'header.userSettings.lastSettlementRun' | translate }}: {{ lastSettlementRun | localizedDate: false : true : true }}
        {{ 'header.userSettings.germanTime' | translate }}
      </p>
    </span>
  </mat-menu>
</div>
